import React, { useEffect, useState } from "react";
import { useForm,Controller } from "react-hook-form";
import EachDay from "./EachDay";
import AddDayForm from "./AddDayForm";

function HoursOfOperationForm({ hof, updateHours }) {
  const [addHour,setAddHour] = useState()

  return (
    <>
      <div className="row mb-2">
        <div className="col-lg-3 col-md-3 lable"> Day</div>
        <div className="col-lg-3 col-md-2 lable"> Time</div>
        <div className="col-lg-2 col-md-2 lable"> Status</div>
        <div className="col-lg-2 col-md-3 lable">Note</div>
      </div>
      <hr />
      {hof &&
        hof.map((item, index) => {
          return <EachDay day={item} hof={hof} key={index} updateHours={updateHours} />;
        })}
      
      <hr/>
      <AddDayForm hof={hof} updateHours={updateHours} />
    </>
  );
}

export default HoursOfOperationForm;
